module.exports = __webpack_public_path__ + "static/img/i8.3bb6bde.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/i8.png
// module id = VenV
// module chunks = 0